<template>
  <div id="app">
    <transition name="silde" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    islogin() {
      let self = this;
      if (localStorage.accessToken) {
        $http.POST({
          url: this.$store.state.apiUrl + "/api/services/app/AdminUser/IsLogin",
          success(res) {
            if (!res) {
              localStorage.removeItem("accessToken");
              self.$message.error('登录失效，请重新登录！')
              self.$router.push({
                path: "/login"
              });
            }
          },
          fail(res) {
            localStorage.removeItem("accessToken");
            self.$message.error('登录失效，请重新登录')
            self.$router.push({
              path: "/login"
            });
          }
        });
      } else {
        localStorage.removeItem("accessToken");
        self.$message.error('登录失效，请重新登录')
        this.$router.push({
          path: "/login"
        });
      }
    }
  },
  created() {
    this.islogin();
  },
  mounted() {}
};
</script>
<style lang="scss">
.silde-enter-active {
  transition: all 0.2s ease;
}
.silde-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.silde-enter, .silde-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: scale(0.9);
  opacity: 0;
}
</style>
